var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebIconsDonar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ee39400a-a451-4734-9bbd-63b4eecb52ed{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:19.86px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ff157830-5612-4c80-8f12-e64114d8a0c8",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ee39400a-a451-4734-9bbd-63b4eecb52ed",
    d: "M243.3,187.08V61.39A27.32,27.32,0,0,0,216,34.07h0a27.32,27.32,0,0,0-27.32,27.32v50.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ee39400a-a451-4734-9bbd-63b4eecb52ed",
    d: "M299.39,187.08V83.77a28,28,0,0,0-28.05-28h0a28,28,0,0,0-28,28v36.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ee39400a-a451-4734-9bbd-63b4eecb52ed",
    d: "M299.39,148.05V128.87a28.22,28.22,0,0,1,28.22-28.22h0a28.23,28.23,0,0,1,28.23,28.22v127A110.08,110.08,0,0,1,245.76,365.89h-14s-47.77,2.53-93-32.57L51.57,243.21a26.33,26.33,0,0,1,1.58-38.12h0a26.32,26.32,0,0,1,34.51-.17l44.55,38.25V84a28.23,28.23,0,0,1,28.22-28.22h0A28.23,28.23,0,0,1,188.66,84V187.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.36,239.16a12.52,12.52,0,0,1,9.2,4l4.73,5.13a12.5,12.5,0,0,1-.53,17.53l-43.59,41.79-43.76-40.76a12.36,12.36,0,0,1-.59-17.5l4.7-5a12.38,12.38,0,0,1,17.55-.49l17.36,16.55a6.6,6.6,0,0,0,9.29-.19L254.36,243a12.46,12.46,0,0,1,9-3.82m0-19.86h0a32.57,32.57,0,0,0-23.29,9.89l-7.48,7.75-7.82-7.45A32.23,32.23,0,0,0,179,230.77l-4.7,5a32.21,32.21,0,0,0,1.54,45.61l43.76,40.76a19.86,19.86,0,0,0,27.28-.19l43.59-41.8a32.37,32.37,0,0,0,1.38-45.34l-4.74-5.13a32.52,32.52,0,0,0-23.78-10.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIconsDonar);
export default __webpack_public_path__ + "static/media/web-icons_donar.5e58e2bddcc019ba52696d24c709267c.svg";
export { ForwardRef as ReactComponent };